import axios from 'axios';
import { URL_BASE } from '../../../config/config';

const RESOURCE = 'permissions';

export default {
    namespaced: true,

    actions: {
        storePermission(context, params) {
            context.commit('PRELOADER', true, { root: true });
            return new Promise((resolve, reject) => {
                axios
                    .post(`${URL_BASE}${RESOURCE}`, params)
                    .then((response) => resolve(response.data))
                    .catch((error) => {
                        console.error('Erro ao salvar permissão:', error);
                        reject(error);
                    })
                    .finally(() => context.commit('PRELOADER', false, { root: true }));
            });
        }
    },

    getters: {
        /**
         * Getter auxiliar para verificar o perfil do usuário (privado ao módulo).
         */
        isMasterOrManager: (state, getters, rootState) => {
            const me = rootState.auth?.me;
            return me && ['Master', 'Gerente'].includes(me.profile);
        },
        
        /**
         * Getter para verificar se o usuário tem uma permissão global.
         */
        userHasGlobalPermission: (state, getters, rootState) => (permissionDescription) => {
            const me = rootState.auth?.me;
            if (!me || !me.permissions) {
                return false;
            }
            return me.permissions.some(p => p.description === permissionDescription);
        },

        /**
         * Calcula as permissões do usuário logado para uma propriedade específica.
         */
        getPermissionsForProperty: (state, getters, rootState) => (property) => {
            const me = rootState.auth?.me;
            const isMasterOrManager = getters.isMasterOrManager;

            if (isMasterOrManager) {
                return {
                    store_property: true,
                    active_property: true,
                    update_active_property: true,
                    view_owners_others: true,
                    colaborator: true
                };
            }

            let isColaborator = false;
            if (Array.isArray(property.colaborators) && property.colaborators.length > 0) {
                isColaborator = property.colaborators.some(
                    (colab) => colab.user_id == me.id
                );
            }

            return {
                store_property: false,
                active_property: false,
                update_active_property: false,
                view_owners_others: true,
                colaborator: isColaborator
            };
        },

        /**
         * Getter unificado e principal para verificar qualquer tipo de permissão.
         *
         * @param {string} permission - A chave da permissão.
         * @param {Object} [context] - Opcional. Um objeto de contexto (ex: { item: sua_propriedade }).
         * @returns {boolean}
         */
        can: (state, getters, rootState) => (permission, context = null) => {
            const me = rootState.auth?.me;
            if (!me) {
                return false;
            }

            // Regra 1: Master e Gerente têm acesso total.
            if (getters.isMasterOrManager) {
                return true;
            }

            // Regra 2: Checa permissões de item se um contexto for fornecido.
            if (context && context.item) {
                const { item } = context;

                // Lógica para edição de item 'Pendente' para colaboradores.
                const isColaborator = Array.isArray(item.colaborators) && 
                                      item.colaborators.some(colab => colab.user_id === me.id);
                                      
                
                if (permission === 'Edita imóvel pendente' && isColaborator && item.status === 'Pendente') {
                    return true;
                }

                if (permission === 'Edita imóvel ativo da carteira') {
                    if(!isColaborator){
                        return false;
                    }
                }

                if (permission === 'Excluir imóvel da carteira') {
                    if(!isColaborator){
                        return false;
                    }
                }

                if (permission === 'Acesso aos proprietarios de outras carteiras') {
                    // Primeiro, verifica se tem permissão global — se tiver, retorna true imediatamente
                    if (getters.userHasGlobalPermission(permission)) {
                        return true;
                    }

                    // Se não tiver permissão global, aplica a regra de colaborador
                    if(!isColaborator){
                        return false;
                    } else {
                        return true;
                    }
                }

                // Permissões baseadas no getter getPermissionsForProperty.
                const propertyPermissions = getters.getPermissionsForProperty(item);
                if (propertyPermissions[permission]) {
                    return true;
                }
            }

            // Regra 3: Checa permissões globais.
            return getters.userHasGlobalPermission(permission);
        },
    }
};